var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":_vm.openSlideMenu}},[_c('MenuIcon',{staticClass:"text-black h-8"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }